import React, { FC } from 'react';

import { FormNavigationProps } from 'components/FormNavigation/FormNavigation';

import FinancialDashboardNavigation from './FinancialDashboardNavigation';

function withFinancialDashboardNavigation<P extends { NavigationComponent?: FC<FormNavigationProps> }>(
  WrappedComponent: React.ComponentType<P>,
): (props: Omit<P, 'NavigationComponent'>) => JSX.Element {
  const Enhanced = (props: Omit<P, 'NavigationComponent'>): JSX.Element => (
    <WrappedComponent {...(props as P)} NavigationComponent={FinancialDashboardNavigation} />
  );
  Enhanced.displayName = `withFDNav(${WrappedComponent.displayName || WrappedComponent.name})`;
  return Enhanced;
}

export default withFinancialDashboardNavigation;
